<template>
    <div style="background:#F9F9FB">
        <Mainlayout></Mainlayout>
        <CCol sm="12" style="background-size: cover; color: #fff" :style="{ backgroundImage: `url(${backgroundUrl})` }">
            <CCol sm="12" lg="12">
                <CRow>
                    <CCol sm="7" lg="7">
                        <div style="margin-top: 25%;margin-bottom:40%">
                            <h3 class="mt-3 mb-4 text-white custom-header-subtitle text-left poppin-font ml-5">
                                {{ $t('sport_center_pro') }}
                            </h3>
                            <h1 class="custom-header-title text-left">
                                <strong>{{ $t('Welcome to Sport') }}
                                                       <br />{{ $t('Center') }} </strong>
                            </h1><br>
                            <label class="custom-14px-500 ml-5">
                                                {{ $t('supported_by') }}
                                                                            <br /> <br />
                                                                            <img src="../assets/img/nike.png" style="width:120px" class="mr-3"/>
                                            
                                            <img src="../assets/img/esprit.png" style="width:120px" class="mr-3"/>
                                            
                                            <img src="../assets/img/watch.png" style="width:120px" class="mr-3"/>
                                            
                                            <img src="../assets/img/balance.png" style="width:100px" class="mr-3"/>
                                                                        </label>
    
    
    
    
                        </div>
                        <br /><br /><br />
    
                    </CCol>
                    <CCol sm="5" lg="5" class="mt-5">
                        <br /><br /><br /><br /><br />
                        <h3 class="mt-5 mb-4 text-white custom-24px-500 text-left poppin-font ml-5">
                            <br /><br /> {{ $t('intro_text') }}
                            <br /><br />
                            <span class="custom-blur-radius-bottom-right p-10 mt-5">
                                                {{ $t('get_started') }} <img src="../assets/img/arrow-bottom.png" />
                                                                  </span>
                        </h3>
                    </CCol>
                </CRow>
            </CCol>
        </CCol>
    
        <CCol sm="12" class="bg-grey">
            <CCol sm="12" lg="12">
                <div class="text-left">
                    <br /><br /><br />
                    <CCol sm="12" style="width: 90%; margin: auto;">
                        <CRow>
                            <CCol sm="6">
                                <h1 class="custom-64px-500 text-black mb-3">
                                    {{ $t('Main Features') }}
                                </h1>
                                <br /> <br />
                            </CCol>
                            <CCol sm="6">
                                <div class="float-right">
                                    <img src="../assets/img/feature.png" style="max-width:60px" />
                                </div>
                            </CCol>
                            <CCol sm="3">
                                <CCard class="bg-white b-20 p-20" style="border:none">
                                    <div class="m-4 text-black">
                                        <img src="../assets/img/bullet.png" style="max-width:30px" />
                                        <h3 class="custom-20px-500 text-black mt-3">
                                            {{ $t('Team List') }}
                                        </h3>
                                        <label class="custom-16px-400">
                                                        {{ $t('list_of_teams') }}
                                                                            </label>
    
                                        <label class="custom-14px-500 text-black mt-3">
                                                        {{ $t('tournament_list') }} <img style="max-width:30px" src="../assets/img/arrow-right.png" />
                                                                            </label>
                                    </div>
    
                                </CCard>
                            </CCol>
                            <CCol sm="3">
                                <CCard class="bg-white b-20 p-20" style="border:none">
                                    <div class="m-4 text-black">
                                        <img src="../assets/img/payment.png" style="max-width:30px" />
                                        <h3 class="custom-20px-500 text-black mt-3">
                                            {{ $t('Payment') }}
                                        </h3>
                                        <label class="custom-16px-400">
                                                        {{ $t('payment_page_description') }}
                                                                            </label>
    
                                        <label class="custom-14px-500 text-black mt-3">
                                                        {{ $t('Tournament Registration') }} <img style="max-width:30px" src="../assets/img/arrow-right.png" />
                                                                            </label>
                                    </div>
    
                                </CCard>
                            </CCol>
                            <CCol sm="3">
                                <CCard class="bg-white b-20 p-20" style="border:none">
                                    <div class="m-4 text-black">
                                        <img src="../assets/img/VolumeDown.png" style="max-width:30px" />
                                        <h3 class="custom-20px-500 text-black mt-3">
                                            {{ $t('Announcement') }}
                                        </h3>
                                        <label class="custom-16px-400">
                                                        {{ $t('announcements_description') }}
                                                                            </label>
    
                                        <label class="custom-14px-500 text-black mt-3">
                                                        {{ $t('Tournament Message') }} <img style="max-width:30px" src="../assets/img/arrow-right.png" />
                                                                            </label>
                                    </div>
    
                                </CCard>
                            </CCol>
                            <CCol sm="3">
                                <CCard class="bg-white b-20 p-20" style="border:none">
                                    <div class="m-4 text-black">
                                        <img src="../assets/img/building.png" style="max-width:30px" />
                                        <h3 class="custom-20px-500 text-black mt-3">
                                            {{ $t('Venue') }}
                                        </h3>
                                        <label class="custom-16px-400">
                                                        {{ $t('venue_description') }}
                                                                            </label>
    
                                        <label class="custom-14px-500 text-black mt-3">
                                                        {{ $t('Tournament Location') }}<img style="max-width:30px" src="../assets/img/arrow-right.png" />
                                                                            </label>
                                    </div>
    
                                </CCard>
                            </CCol>
                        </CRow>
                    </CCol>
    
    
    
    
                </div>
            </CCol>
            <br /><br />
        </CCol>

       
    
    
        <CCol sm="12" class="bg-grey">
                <div class="text-center">
                    <br />
                    <h1 class="custom-48px-500 text-black poppin-font text-48px">
                        {{ $t('Schedule') }}
                    </h1>
                    <div class="text-center mt-4">
                        <CCol sm="12" style="width: 90%; margin: auto;">
                            <CRow>
                                <div class="text-center mt-4">
                                    <CRow>
                                        <CCol sm="12">
                                            <h2 class="text-left custom-20px-600">
                                                {{ monthName }}
                                                <span class="font-color-064BB4 ml-2">{{ currentYear }}</span>
                                                <span @click="previousMonth" class="clickable text-left m-2">
                                            <img src="../assets/img/left.png" style="width: 30px" class="ml-2" />
                                        </span>
                                                <span @click="nextMonth" class="clickable text-left m-2">
                                            <img src="../assets/img/right.png" style="width: 30px" />
                                        </span>
                                            </h2>
                                        </CCol>
                                    </CRow>
                                    <div class="calendar-container">
    <div class="calendar-grid">
        <div class="calendar-day-header" v-for="day in daysOfWeek" :key="day">{{ day }}</div>
        <div v-for="day in daysInMonth" :key="day.date" class="calendar-day-box" :class="{ 'current-day': isToday(day.date) }">
            <span class="day-number">{{ day.date.getDate() }}</span>
            <div v-if="day.events.length > 0" class="events">
                <div v-for="event in day.events" :key="event.Id" class="event-item" @click="GoToDetail(event.Id)">
                    {{ event.Title }}
                </div>
            </div>
        </div>
    </div>
</div>
                                </div>

                                <CCol sm="12" class="mt-5 mb-5">
                                    <img src="../assets/img/btntour.png" style="max-width:300px;" @click="GoToScore()"/>
                                </CCol>
                                <CCol sm="12">
                                    <CRow>
                                        <CCol sm="6">
                                            <!-- <h3 class="custom-20px-600 text-left mt-4">18 January, 2024</h3> -->
                                        </CCol>
                                        <CCol sm="6">
                                            <div class="text-right float-right">
                                                <CSelect class="mb-0 mx-1 mt-4" size="sm" value="Medium" :options="['Today','Tomorrow']" custom/>
                                            </div>
                                        </CCol>
                                        <CCol sm="3" v-for="(item,index) in tour" v-bind:key="item.Id">
                                            <CCard class="p-2">
    
                                                <img v-if="item.FilePath != null" :src="getThumbnail(index)" style="max-width: 100%;border-radius:20px" />
                                                <img v-else src="../assets/img/photo1.png" />
                                                <CRow>
                                                    <CCol sm="6">
                                                        <div class="custom-label-tag-blue-light mt-2">
                                                            {{ item.Time }}
                                                        </div>
                                                    </CCol>
                                                    <CCol sm="6">
                                                        <div class="mt-2">
    
                                                            <img style="width:20px" src="../assets/img/user.png" /> Registered
                                                        </div>
                                                    </CCol>
                                                    <CCol sm="12">
                                                        <h3 class="custom-14px-500 text-left mt-3">
                                                            <b>
                                                                                        {{ item.Title }}
                                                                                    </b>
                                                        </h3>
                                                    </CCol>
                                                    <CCol sm="8">
                                                        <p class="custom-16px-600 text-left"><b>RM {{ item.Amount }}</b></p>
                                                    </CCol>
                                                    <CCol sm="4">
                                                        <p v-if="item.IsAcceptRegistration === true" class="custom-14px-500" style="cursor: pointer;" @click="GoToDetail(item.Id)">
                                                            Join Now <img style="width: 20px" src="../assets/img/arrow-right1.png" />
                                                        </p>
                                                        <p v-else class="custom-14px-500" style="color: #636f83; cursor: not-allowed;">
                                                            Join Now <img style="width: 20px" src="../assets/img/arrow-right1.png" />
                                                        </p>
                                                    </CCol>
                                                </CRow>
                                            </CCard>
                                        </CCol>
    
                                    </CRow>
                                </CCol>
    
                            </CRow>
                        </CCol>
                    </div>
    
    
                </div>
        </CCol>
    
        <CCol sm="12" class="bg-grey">
            <CCol sm="12" lg="12">
                <div class="text-center">
                    <br /><br />
                    <CCol sm="12" style="width: 90%;background-size: cover; margin: auto;">
                        <br />
                        <CRow class="mt-5">
                            <CCol sm="12">
                                <h1 class="custom-header-title-choose text-black mt-3 p-40 text-center poppin-font text-60px">{{ $t('Events and News')}}</h1>
    
                                <br /><br />
                            </CCol>
                            <CCol sm="4">
                                <img style="max-width:100%" src="../assets/img/Image1.png" />
                                <br />
                                <CRow>
                                    <CCol sm="6">
                                        <div class="text-left mt-3">
                                            <span class="custom-rectangle-blue text-white mt-3">{{ $t('Fitness')}}</span>
                                        </div>
                                    </CCol>
                                    <CCol sm="6">
                                        <p class="custom-18px-500 color-brown mt-4 text-right">
                                            22 Nov 2022
                                        </p>
                                    </CCol>
                                </CRow>
                                <p class="custom-20px-500 mt-3 text-left">
                                    {{ $t('fitness_routines')}}
                                </p>
                                <p class="custom-18px-500 color-brown text-left">
                                    {{ $t('fitness_description')}}
                                </p>
                                <CRow>
                                    <CCol sm="6">
                                        <p class="custom-14px-500 text-left">{{ $t('Read More')}} <img style="width:20px" src="../assets/img/arrow-right.png" /></p>
                                    </CCol>
                                    <CCol sm="6"></CCol>
                                </CRow>
                            </CCol>
                            <CCol sm="4">
                                <img style="max-width:100%" src="../assets/img/Image2.png" />
                                <CRow>
                                    <CCol sm="6">
                                        <div class="text-left mt-3">
                                            <span class="custom-rectangle-blue text-white mt-3">{{ $t('Fitness')}}</span>
                                        </div>
                                    </CCol>
                                    <CCol sm="6">
                                        <p class="custom-18px-500 color-brown mt-4 text-right">
                                            22 Nov 2022
                                        </p>
                                    </CCol>
    
                                </CRow>
                                <p class="custom-20px-500 mt-3 text-left">
                                    {{ $t('fitness_routines_1') }}
                                </p>
                                <p class="custom-18px-500 color-brown text-left">
                                    {{ $t('fitness_routines_1_Desc')}}
                                </p>
                                <CRow>
                                    <CCol sm="6">
                                        <p class="custom-14px-500 text-left">{{ $t('Read More')}} <img style="width:20px" src="../assets/img/arrow-right.png" /></p>
                                    </CCol>
                                    <CCol sm="6"></CCol>
                                </CRow>
                            </CCol>
                            <CCol sm="4">
                                <img style="max-width:100%" src="../assets/img/Image3.png" />
                                <CRow>
                                    <CCol sm="6">
                                        <div class="text-left mt-3">
                                            <span class="custom-rectangle-blue text-white mt-3">{{ $t('Fitness')}}</span>
                                        </div>
                                    </CCol>
                                    <CCol sm="6">
                                        <p class="custom-18px-500 color-brown mt-4 text-right">
                                            22 Nov 2022
                                        </p>
                                    </CCol>
                                </CRow>
                                <p class="custom-20px-500 mt-3 text-left">
                                    {{ $t('fitness_routines_2') }}
                                </p>
                                <p class="custom-18px-500 color-brown text-left">
                                    {{ $t('fitness_routines_2_Desc') }}
                                </p>
                                <CRow>
                                    <CCol sm="6">
                                        <p class="custom-14px-500 text-left">{{ $t('Read More')}} <img style="width:20px" src="../assets/img/arrow-right.png" /></p>
                                    </CCol>
                                    <CCol sm="6"></CCol>
                                </CRow>
                            </CCol>
    
                        </CRow>
    
    
                    </CCol>
                </div>
            </CCol>
    
        </CCol>
    
        <CCol sm="12">
            <div class="text-center">
                <br /><br />
                <CCol sm="8" style="width: 90%;background-size: cover; margin: auto;">
                    <br />
                    <CRow class="mt-5">
                        <CCol sm="12">
                            <h1 class="custom-header-title-choose text-black mt-3 p-40 text-center poppin-font custom-48px-600">{{ $t('review')}}</h1>
                            <br /><br />
                            <div class="position-relative">
                                <img src="../assets/img/bos.jpg" style="max-width:250px; position: absolute; top: 25%; left: 0%; transform: translate(-50%, -50%);" class="mb-3" />
                                <div class="custom-blue-black">
                                    <div class="text-center" style="margin-left:20%">
    
                                        <p class="custom-40px-600 text-left">
                                            <img src="../assets/img/quote.png" style="margin-top:-50px;" />
                                            <br /> {{ $t('feedback')}}
                                            <CRow>
                                                <CCol sm="10">
                                                    <h3 class="custom-17px-400 text-left text-white mt-4">Rasid Maasom, </h3>
                                                    <p class="custom-14px-500 text-left text-white">Co founder -</p>
                                                </CCol>
                                                <CCol sm="2">
                                                    <img src="../assets/img/Arrow-Right2.png" style="max-width:30px" class="mt-3" />
                                                </CCol>
                                            </CRow>
    
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </CCol>
                    </CRow>
                </CCol>
            </div>
        </CCol>
    
        <CCol sm="12">
            <CCol sm="10" style="width: 90%;background-size: cover; margin: auto;">
                <div class="text-center custom-card-grey mb-5 mt-5">
                    <h3 class="custom-48px-600 mt-5">{{ $t('Have a question or feedback?')}}</h3>
                    <p class="custom-16px-400">{{ $t('Have a question or feedback?')}} {{ $t('fill_out') }}</p>
                    <br /><br />
                    <span class="custom-blur-radius-bottom-right p-10 mt-5 text-white p-20 mb-5">
                    {{ $t('Contact Us') }} <img style="width:20px" src="../assets/img/Calling.png" />
                                                               
                                                                </span>
                    <br /><br /> <br /><br />
    
                </div>
    
            </CCol>
        </CCol>
    
    
    
    
    
        <Footerlayout></Footerlayout>
    
    </div>
</template>

<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";
import moment from "moment";
Vue.use(require("vue-moment"));
Vue.use(Carousel3d);

import backgroundUrl from "../assets/img/Membership.png";
import backgroundUrl1 from "../assets/img/BgPeople.png";
import backgroundGenie from "../assets/img/bggenie.png";
import backgroundUrNoArrow from "../assets/img/bg.png";

import Mainlayout from "../containers/AllHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";
import ToggleCard from '../components/Toggle.vue';

import msalInstance from '../containers/msalService';

export default {
    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        Footerlayout,
        ToggleCard,
    },
    data() {
        return {
            backgroundUrl,
            backgroundUrNoArrow,

            backgroundGenie,
            isActive: false,
            tour: [],
            currentYear: new Date().getFullYear(),
            currentMonth: new Date().getMonth(),
            daysOfWeek: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"]

        };
    },
    created() {
        AOS.init();

    },
    watch: {
        '$i18n.locale': {
            immediate: true,
            handler() {
                this.$forceUpdate(); // Forces re-render on language change
            }
        }
    },
    computed: {
        CreationDate() {
            return moment().startOf('day'); // Start of today
        },
        daysInMonth() {
            const days = [];
            const date = new Date(this.currentYear, this.currentMonth, 1);

            // Adjust start date to Sunday of the week
            date.setDate(date.getDate() - date.getDay());

            // Loop through each day in the calendar grid (5-6 weeks typically)
            for (let i = 0; i < 42; i++) {
                const dayEvents = this.getEventsForDate(date);
                days.push({ date: new Date(date), events: dayEvents });
                date.setDate(date.getDate() + 1); // Go to next day
            }
            return days;
        },
        monthName() {
            return new Date(this.currentYear, this.currentMonth).toLocaleString("default", { month: "long" });
        }
    },
    async mounted() {

        this.GetListTour();
    },
    methods: {
        isTimeAfterToday(time) {
            const itemTime = moment(time).startOf('day');
            return itemTime.isAfter(this.CreationDate);
        },
        toggle() {
            this.isActive = !this.isActive;
        },
        GetListTour() {
            this.$API
                .get(this.$GetListTournamentPublished)
                .then((response) => {
                    if (response.status == 200 && response.data != null) {
                        this.tour = response.data;
                        this.getThumbnail(this.tour.FilePath);
                    }
                });
        },
        getThumbnail(index) {
            return (
                "https://sportcenter.s3.ap-southeast-1.amazonaws.com/" + this.tour[index].FilePath
            );
        },
        GoToDetail(id) {
            this.$router.push("RegisterGames?id=" + id);
        },
        getEventsForDate(date) {
            // Get events that match the specific day
            return this.tour.filter(event => {
                const eventDate = new Date(event.Start);
                return (
                    eventDate.getFullYear() === date.getFullYear() &&
                    eventDate.getMonth() === date.getMonth() &&
                    eventDate.getDate() === date.getDate()
                );
            });
        },
        isToday(date) {
            const today = new Date();
            return (
                today.getFullYear() === date.getFullYear() &&
                today.getMonth() === date.getMonth() &&
                today.getDate() === date.getDate()
            );
        },
        previousMonth() {
            if (this.currentMonth === 0) {
                this.currentMonth = 11;
                this.currentYear--;
            } else {
                this.currentMonth--;
            }
        },
        nextMonth() {
            if (this.currentMonth === 11) {
                this.currentMonth = 0;
                this.currentYear++;
            } else {
                this.currentMonth++;
            }
        },
        GoToScore()
        {
            this.$router.push("MatchingOpponent");
        }





    }



};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans&display=swap');
body {
    top: 0 !important;
    font-family: 'Poppins', sans-serif;
}
</style>